import { omit } from 'lodash-es';

import { BASE_SIZE } from '../constant';

export const BASE_TOGGLE_BUTTON_SIZE = omit(BASE_SIZE, 'LG');
